// extracted by mini-css-extract-plugin
module.exports = {"icon-circle":"icon_circle__icon-circle___opjqM"};